import { Flow, FlowOrder } from "@spike/app2-sitemap/src/auth.js";
import { decode, RedirectData } from "@spike/app2-sitemap/src/lib/redirect.js";
import { reactive } from "vue";
import { RouteRecordRaw } from "vue-router";
import { Screen } from "./routes.js";

// const $routeName = location.hash === "" ? "/" : location.hash.substring(1);
// console.log("route:", $routeName);

// global state without needing a store: /code/web/vue3/prototype/global-store-test/README.md
// fix annoying cyclic dependencies: routes can't be accessed in root scope - need init() - see ./main.ts
let navigation = reactive<RouteRecordRaw[]>([]);
export function init(routes: RouteRecordRaw[]) {
  navigation = reactive<RouteRecordRaw[]>(routes);
  // initRedirectData();
}

function onClick(item: RouteRecordRaw) {
  // clicked item is current
}

function findMenuItemByName(name: string | Screen): RouteRecordRaw | undefined {
  for (const i of navigation) {
    if (i.name === name) {
      return i;
    }
  }
  return undefined;
}

export function setActive(name: string | Screen, setPath: boolean = false, step?: string): void {
  const item = findMenuItemByName(name);
  if (item) {
    onClick(item);
    if (setPath) {
      const i = item.path.indexOf(":");
      const p = i === -1 ? item.path : item.path.substring(0, i);
      if (step) {
        location.hash = p + "/" + step;
      } else {
        location.hash = p;
      }
    }
  } else {
    console.log("can't find:", name);
  }
}

//#region flow

let _completed: Set<Screen> = new Set();
let _order: Screen[] = [];
let _flow: Flow | undefined;

export function startFlow(flow: Flow, complete?: Screen[]) {
  // console.log("startFlow:", flow);
  _flow = flow;
  _order = FlowOrder[flow];
  _completed = complete ? new Set(complete) : new Set();
}

export function currentFlow() {
  return _flow;
}

export function complete(screen: Screen) {
  // console.log("complete:", _flow, screen);
  _completed.add(screen);
}

export function isComplete(screen: Screen) {
  return _completed.has(screen);
}

export function prevScreensComplete(screen: Screen) {
  // console.log("prevScreensComplete check:", _flow, screen);
  const i = _order.indexOf(screen);
  if (i > 0) {
    const prior = _order.slice(0, i);
    for (const s of prior) {
      if (!isComplete(s)) {
        // console.log("prevScreensComplete incomplete:", s);
        setActive(s, true);
        return; // early out
      }
    }
  }
}

//#endregion

//#region redirect data

let redirect: RedirectData;

function initRedirectData() {
  const fullPath = window.location.pathname + window.location.hash;
  const x = decode(fullPath);
  // console.log("RedirectData:", JSON.stringify(x));
  redirect = x;

  // chop off the data part
  // if (x.data) {
  //   const lastSlash = window.location.hash.lastIndexOf("/");
  //   window.location.hash = window.location.hash.substring(0, lastSlash);
  // }
}

export function getRedirectData(app: string, screen: string): RedirectData | undefined {
  initRedirectData();
  if (screen[0] == "/") screen = screen.substring(1);
  if (redirect && redirect.app === app && redirect.screen === screen) {
    return redirect;
  }
  return undefined;
}

//#endregion
